import React from "react";
import staff1 from "../images/gnnot/wetransfer_2025-01-30_1603/Rawan.webp";
import staff2 from "../images/gnnot/wetransfer_2025-01-30_1603/Monica.webp";
import staff3 from "../images/gnnot/wetransfer_2025-01-30_1603/Fidaa.webp";
import staff4 from "../images/gnnot/wetransfer_2025-01-30_1603/Nujud.webp";
import staff5 from "../images/gnnot/wetransfer_2025-01-30_1603/Sara.webp";
import staff6 from "../images/gnnot/wetransfer_2025-01-30_1603/Angela.webp";
import staff7 from "../images/gnnot/wetransfer_2025-01-30_1603/Suha.webp";
import staff9 from "../images/gnnot/wetransfer_2025-01-30_1603/Ola.webp";
import staff10 from "../images/gnnot/wetransfer_2025-01-30_1603/Tatyana.webp";
import staff11 from "../images/gnnot/wetransfer_2025-01-30_1603/Huda.webp";
import staff12 from "../images/gnnot/wetransfer_2025-01-30_1603/Mirvat.webp";
import staff13 from "../images/gnnot/wetransfer_2025-01-30_1603/Ghada.webp";
import staff14 from "../images/gnnot/wetransfer_2025-01-30_1603/Maria.webp";
import staff15 from "../images/gnnot/wetransfer_2025-01-30_1603/Dorit.webp";
import staff16 from "../images/gnnot/wetransfer_2025-01-30_1603/Halleli.webp";
import staff17 from "../images/gnnot/wetransfer_2025-01-30_1603/Leen.webp";
import staff18 from "../images/gnnot/wetransfer_2025-01-30_1603/Lina.webp";
import staff19 from "../images/gnnot/wetransfer_2025-01-30_1603/Rania.webp";
import staff20 from "../images/gnnot/wetransfer_2025-01-30_1603/Rasha.webp";
import staff21 from "../images/gnnot/wetransfer_2025-01-30_1603/Tamar.webp";
import staff22 from "../images/gnnot/wetransfer_2025-01-30_1603/Vardit.webp";
import staff23 from "../images/gnnot/wetransfer_2025-01-30_1603/Walaa.webp";
import staff24 from "../images/gnnot/wetransfer_2025-01-30_1603/Manal.webp";

import "./staff.css";
import Header from "./header";

const staffMembers = [
  {
    id: 1,
    name: "Rawan",
    job: "Kidnergarten Director",
    class: "PhD. in Education",
    experience: " 12 years of working experience",
    profilePicture: staff1,
  },
  {
    id: 2,
    name: "Monica",
    job: "M.A in Education  ",
    class: "Toddlers group",
    experience: "29 years of teaching experience",
    profilePicture: staff2,
  },
  {
    id: 3,
    name: "Fida'a",
    job: "Certificated Teacher ",
    class: "Toddlers group",
    experience: "20 years of teaching experience",
    profilePicture: staff3,
  },
  {
    id: 4,
    name: "Nujud",
    job: "Certificated Teacher ",
    class: "Toddlers group",
    experience: "27 years of teaching experience",
    profilePicture: staff4,
  },
  {
    id: 5,
    name: "Sara",
    job: "Certificated Teacher  ",
    class: "Babies group",
    experience: "16 years of teaching experience",
    profilePicture: staff5,
  },
  {
    id: 6,
    name: "Angela",
    job: "Certificated Teacher",
    class: "Babies & toddlers group",
    experience: "12 years of teaching experience",
    profilePicture: staff6,
  },
  {
    id: 7,
    name: "Suha",
    job: "Certificated Teacher ",
    class: "Babies & toddlers group",
    experience: "11 years of teaching experience",
    profilePicture: staff7,
  },


  {
    id: 8,
    name: "Ola",
    job: "Certificated Teacher ",
    class: "Babies group",
    experience: "10 years of teaching experience",
    profilePicture: staff9,
  },
  {
    id: 9,
    name: "Tatyana",
    job: "Certificated Teacher ",
    class: "Toddlers group",
    experience: "10 years of teaching experience",
    profilePicture: staff10,
  },
  {
    id: 10,
    name: "Huda",
    job: "Certificated Teacher ",
    class: "Babies group",
    experience: " 10 years of teaching experience",
    profilePicture: staff11,
  },
  {
    id: 11,
    name: "Mirvat",
    job: "Assistant Teacher ",
    class: "Toddlers group",
    experience: "5+ years of teaching experience",
    profilePicture: staff12,
  },
  {
    id: 12,
    name: "Ghada",
    job: "Certificated Teacher ",
    class: "Babies and toddlers group",
    experience: "3 years of teaching experience",
    profilePicture: staff13,
  },
  {
    id: 13,
    name: "Maria",
    job: "B.A in Education ",
    class: "Toddlers group",
    experience: "2 years of teaching experience",
    profilePicture: staff14,
  },
  {
    id: 14,
    name: "Dorit",
    job: "---- ",
    class: "---",
    experience: "--",
    profilePicture: staff15,
  },
  {
    id: 15,
    name: "Halleli",
    job: "- ",
    class: "-",
    experience: "-",
    profilePicture: staff16,
  },

  {
    id: 16,
    name: "Leen",
    job: "-",
    class: "-",
    experience: "-",
    profilePicture: staff17,
  },
  {
    id: 17,
    name: "Lina",
    job: "- ",
    class: "-",
    experience: "-",
    profilePicture: staff18,
  },

  {
    id: 18,
    name: "Rania",
    job: "- ",
    class: "-",
    experience: "-",
    profilePicture: staff19,
  },
  {
    id: 19,
  name: "Rasha",
    job: "- ",
    class: "-",
    experience: "-",
    profilePicture: staff20,
  },
  {
    id: 20,
   name: "Tamar",
    job: "- ",
    class: "-",
    experience: "-",
    profilePicture: staff21,
  },
  {
    id: 21,
    name: "Vardit",
    job: "- ",
    class: "-",
    experience: "-",
    profilePicture: staff22,
  },
  {
    id: 22,
    name: "Walaa",
    job: "- ",
    class: "-",
    experience: "-",
    profilePicture: staff23,
  },
  {
    id: 23,
   name: "Manal",
    job: "- ",
    class: "-",
    experience: "-",
    profilePicture: staff24,
  },
  
];

const StaffPage = () => {
  return (
    <div>
<Header />
<div className="staff-container">
    
      <h2>Staff Members</h2>
      
      <div className="staff-list">
        {staffMembers.map((staff, index) => {
          // Assign background class based on the index (cycles every 3 staff members)
          const bgClass = `bg-${(index % 3) + 1}`;
          const colorClass = `color-${(index % 3) + 1}`;
          return (
            <div key={staff.id} className={`staff-member ${bgClass}`}>
              <img loading="lazy"
                src={staff.profilePicture}
                alt={`${staff.name}'s profile`}
                className="staff-img"
              />
              <h3 className={colorClass}>{staff.name} </h3>

              <p><strong>Job:</strong> {staff.job}</p>
              <p><strong>Class:</strong> {staff.class}</p>
              <p><strong>Experience:</strong> {staff.experience}</p>
            </div>
          );
        })}                                                                               
      </div>
    </div>
    </div>
    
  );
};

export default StaffPage;
